// SmartCases Produktdaten (automatisch generiert)
export const CATEGORIES = {
  "pos": "Cases für Servicekräfte",
  "laden": "Ladestationen für Cases",
  "staender": "Ständer & Halterungen",
  "zubehoer": "Zubehör & Kabel",
  "schutz": "Displayschutz"
};

export const PRODUCTS = [
  {
    "slug": "kellnerplus-pro",
    "name": "KellnerPlus Pro (ab iPhone 15 / iPad 10. Gen)",
    "category": "pos",
    "description": "Robustes, kabelloses Mobile-Kassensystem: Das stoßfeste Case schützt dein iPhone oder iPad im harten Service-Alltag und lädt es ohne Kabel – einfach auf die passende Ladestation legen. Optional mit integrierter Kartenzahlungs-Aufnahme für bargeldloses Kassieren direkt am Tisch. Militärstandard-Schutz, ergonomischer Griff und volle Kompatibilität mit dem KellnerPlus-Zubehör.",
    "hasPayment": true,
    "variantLabel": "Gerätemodell",
    "variants": [
      {
        "label": "iPhone 16",
        "price": 264,
        "pricePayment": 340
      },
      {
        "label": "iPhone 16e (A18)",
        "price": 264,
        "pricePayment": 340
      },
      {
        "label": "iPhone 17",
        "price": 264,
        "pricePayment": 340
      },
      {
        "label": "iPhone 17e (A19)",
        "price": 264,
        "pricePayment": 340
      },
      {
        "label": "iPad 11″ (A16, 10. Gen)",
        "price": 404,
        "pricePayment": 480
      },
      {
        "label": "iPad mini 8,3″ (A17 Pro) (7./6. Gen)",
        "price": 404,
        "pricePayment": 480
      }
    ],
    "images": [
      "/smartcases/kellnerplus-pro-0.webp",
      "/smartcases/kellnerplus-pro-1.webp",
      "/smartcases/kellnerplus-pro-2.webp",
      "/smartcases/kellnerplus-pro-3.webp",
      "/smartcases/kellnerplus-pro-4.webp",
      "/smartcases/kellnerplus-pro-5.webp",
      "/smartcases/kellnerplus-pro-6.webp",
      "/smartcases/kellnerplus-pro-7.webp"
    ]
  },
  {
    "slug": "kassenpilot-system",
    "name": "KassenPilot System (bis iPhone 15 / iPad 9. Gen.)",
    "category": "pos",
    "description": "Das mobile Kassen-Tool für besonders schnelle Bezahlvorgänge direkt am Gast: Robustes Case mit kabelloser Ladefunktion für Smartphone oder Tablet. In der Payment-Variante inklusive Aufnahme für einen Kartenleser – so kassierst du bargeldlos am Tisch, an der Theke oder im Außenbereich.",
    "hasPayment": true,
    "variantLabel": "Gerätemodell",
    "variants": [
      {
        "label": "iPhone 14/13/12 (A15 Bionic, A14 Bionic)",
        "price": 224,
        "pricePayment": 256
      },
      {
        "label": "iPhone 14/13/12 Plus/Pro Max (A16 Bionic, A15 Bionic, A12 Bionic)",
        "price": 224,
        "pricePayment": 256
      },
      {
        "label": "iPhone 15 (A16 Bionic)",
        "price": 224,
        "pricePayment": 256
      },
      {
        "label": "iPhone 15 Plus/Pro Max (A17 Pro)",
        "price": 224,
        "pricePayment": 256
      },
      {
        "label": "iPhone SE (2./3. Gen)",
        "price": 224,
        "pricePayment": 256
      },
      {
        "label": "Lenovo Tab M8 (3. Gen)",
        "price": 308,
        "pricePayment": 334
      },
      {
        "label": "Lenovo Tab K10",
        "price": 328,
        "pricePayment": 350
      },
      {
        "label": "iPad mini 7,9″ (A12 Bionic) (5./4. Gen)",
        "price": 358,
        "pricePayment": 389
      },
      {
        "label": "Google Pixel Tablet",
        "price": 404,
        "pricePayment": 427
      },
      {
        "label": "iPad 10,2″ (A13 Bionic) (9./8./7. Gen), iPad Pro 10,5″ (1. Gen)",
        "price": 404,
        "pricePayment": 427
      }
    ],
    "images": [
      "/smartcases/kassenpilot-system-0.webp",
      "/smartcases/kassenpilot-system-1.webp",
      "/smartcases/kassenpilot-system-2.webp",
      "/smartcases/kassenpilot-system-3.webp",
      "/smartcases/kassenpilot-system-4.webp",
      "/smartcases/kassenpilot-system-5.webp",
      "/smartcases/kassenpilot-system-6.webp",
      "/smartcases/kassenpilot-system-7.webp"
    ]
  },
  {
    "slug": "kellnerplus-station",
    "name": "KellnerPlus Station",
    "category": "laden",
    "description": "Das Komplett-System aus kabelloser Ladestation und robustem Case: Hält die Geräte deines Teams dauerhaft geladen und einsatzbereit – Gerät einfach einlegen, fertig. Ideal für Betriebe, in denen mehrere Geräte im Schichtbetrieb genutzt werden.",
    "hasPayment": false,
    "variantLabel": "Gerätemodell",
    "variants": [
      {
        "label": "iPhone 15 (A16 Bionic)",
        "price": 779
      },
      {
        "label": "iPhone 15 Plus (A17 Pro)",
        "price": 779
      },
      {
        "label": "iPad 11″ (A16, 10. Gen)",
        "price": 857
      },
      {
        "label": "iPad mini 8,3″ (A17 Pro) (7./6. Gen)",
        "price": 857
      }
    ],
    "images": [
      "/smartcases/kellnerplus-station-0.webp",
      "/smartcases/kellnerplus-station-1.webp",
      "/smartcases/kellnerplus-station-2.webp",
      "/smartcases/kellnerplus-station-3.webp"
    ]
  },
  {
    "slug": "kassenpilot-staender",
    "name": "KassenPilot Ständer",
    "category": "laden",
    "description": "Die flexible, mobile Arbeitsstation: Gerät am Ständer andocken für den festen Arbeitsplatz mit Dauerladung – und bei Bedarf einfach abnehmen und mobil weiterarbeiten. Die mitgelieferte Drehbasis erlaubt einfaches Umdrehen des Bildschirms zum Gast.",
    "hasPayment": false,
    "variantLabel": "Gerätemodell",
    "price": 389,
    "images": [
      "/smartcases/kassenpilot-staender-0.webp",
      "/smartcases/kassenpilot-staender-1.webp",
      "/smartcases/kassenpilot-staender-2.webp",
      "/smartcases/kassenpilot-staender-3.webp"
    ]
  },
  {
    "slug": "kellnerplus-pro-5fach-ladestation",
    "name": "KellnerPlus Pro 5-fach-Ladestation",
    "category": "laden",
    "description": "Die zentrale Ladestation für Geräte-Flotten: Fünf Schächte laden, organisieren und verwalten bis zu fünf Geräte gleichzeitig – ohne Kabelsalat. So sind alle Geräte zum Schichtbeginn geladen, sortiert und sofort einsatzbereit.",
    "hasPayment": false,
    "variantLabel": "Gerätemodell",
    "price": 857,
    "images": [
      "/smartcases/kellnerplus-pro-5fach-ladestation-0.webp",
      "/smartcases/kellnerplus-pro-5fach-ladestation-1.webp",
      "/smartcases/kellnerplus-pro-5fach-ladestation-2.webp",
      "/smartcases/kellnerplus-pro-5fach-ladestation-3.webp",
      "/smartcases/kellnerplus-pro-5fach-ladestation-4.webp",
      "/smartcases/kellnerplus-pro-5fach-ladestation-5.webp",
      "/smartcases/kellnerplus-pro-5fach-ladestation-6.webp",
      "/smartcases/kellnerplus-pro-5fach-ladestation-7.webp"
    ]
  },
  {
    "slug": "kellnerplus-pro-einzel-ladestation",
    "name": "KellnerPlus Pro Einzel-Ladestation",
    "category": "laden",
    "description": "Kompakte Ladestation für ein einzelnes iPad im KellnerPlus Pro Case: Gerät einfach einlegen und laden – ohne Kabel anstecken zu müssen. Perfekt für Theke, Station oder Büro.",
    "hasPayment": false,
    "variantLabel": "Gerätemodell",
    "price": 233,
    "images": [
      "/smartcases/kellnerplus-pro-einzel-ladestation-0.webp",
      "/smartcases/kellnerplus-pro-einzel-ladestation-1.webp",
      "/smartcases/kellnerplus-pro-einzel-ladestation-2.webp",
      "/smartcases/kellnerplus-pro-einzel-ladestation-3.webp",
      "/smartcases/kellnerplus-pro-einzel-ladestation-4.webp",
      "/smartcases/kellnerplus-pro-einzel-ladestation-5.webp",
      "/smartcases/kellnerplus-pro-einzel-ladestation-6.webp",
      "/smartcases/kellnerplus-pro-einzel-ladestation-7.webp"
    ]
  },
  {
    "slug": "kellnerplus-pro-wechselakku",
    "name": "KellnerPlus Pro Wechselakku",
    "category": "laden",
    "description": "Der Zusatz-Akku für lange Schichten: Liefert Reservestrom für dein iPad im KellnerPlus Pro System – einfach tauschen statt laden, damit dein Team ohne Unterbrechung weiterarbeitet.",
    "hasPayment": false,
    "variantLabel": "Gerätemodell",
    "price": 109,
    "images": [
      "/smartcases/kellnerplus-pro-wechselakku-0.webp",
      "/smartcases/kellnerplus-pro-wechselakku-1.webp"
    ]
  },
  {
    "slug": "kassenpilot-multi-tablet-ladestation",
    "name": "KassenPilot Multi-Tablet-Ladestation",
    "category": "laden",
    "description": "Kabelloses Laden für bis zu fünf Tablets gleichzeitig: Die Mehrfach-Ladestation für das KassenPilot System hält deine gesamte Tablet-Flotte geladen und griffbereit – einlegen, fertig.",
    "hasPayment": false,
    "variantLabel": "Gerätemodell",
    "price": 857,
    "images": [
      "/smartcases/kassenpilot-multi-tablet-ladestation-0.webp",
      "/smartcases/kassenpilot-multi-tablet-ladestation-1.webp",
      "/smartcases/kassenpilot-multi-tablet-ladestation-2.webp",
      "/smartcases/kassenpilot-multi-tablet-ladestation-3.webp",
      "/smartcases/kassenpilot-multi-tablet-ladestation-4.webp"
    ]
  },
  {
    "slug": "kassenpilot-multi-phone-ladestation",
    "name": "KassenPilot Multi-Phone-Ladestation",
    "category": "laden",
    "description": "Ladestation für bis zu sechs Smartphones im KassenPilot Case: Nach dem Service einfach einschieben – schnelles, zuverlässiges Laden ohne einzelne Kabel und ohne Suchen.",
    "hasPayment": false,
    "variantLabel": "Gerätemodell",
    "price": 857,
    "images": [
      "/smartcases/kassenpilot-multi-phone-ladestation-0.webp",
      "/smartcases/kassenpilot-multi-phone-ladestation-1.webp"
    ]
  },
  {
    "slug": "kassenpilot-einzel-ladestation",
    "name": "KassenPilot Einzel-Ladestation",
    "category": "laden",
    "description": "Einzel-Ladestation für ein Tablet im KassenPilot Case: Hält dein Gerät den ganzen Tag geladen und einsatzbereit – ganz ohne Kabelgefummel am Gerät.",
    "hasPayment": false,
    "variantLabel": "Gerätemodell",
    "price": 233,
    "images": [
      "/smartcases/kassenpilot-einzel-ladestation-0.webp",
      "/smartcases/kassenpilot-einzel-ladestation-1.webp"
    ]
  },
  {
    "slug": "gastropro-thekenstaender",
    "name": "GastroPro Thekenständer",
    "category": "staender",
    "description": "Der Thekenständer für sichere, effiziente Gäste-Interaktionen: Dreh- und schwenkbare Basis für Kasse, Empfang, Check-in und Self-Service. Das iPad sitzt geschützt im stabilen Gehäuse und bleibt dauerhaft mit Strom versorgt. In der Payment-Variante inklusive Kartenzahlungs-Halterung und Adapter.",
    "hasPayment": true,
    "variantLabel": "Gerätemodell",
    "variants": [
      {
        "label": "iPad 11″ (A16, 10. Gen)",
        "price": 514,
        "pricePayment": 815
      },
      {
        "label": "iPad Air 11″ (M4, M3, M2)",
        "price": 514,
        "pricePayment": 815
      },
      {
        "label": "iPad Pro 11″ (M4) (5. Gen)",
        "price": 514,
        "pricePayment": 815
      },
      {
        "label": "iPad Pro 11″ (M5)",
        "price": 514,
        "pricePayment": 815
      },
      {
        "label": "iPad Air 13″ (M4, M3, M2)",
        "price": 624,
        "pricePayment": 925
      },
      {
        "label": "iPad Pro 13″ (M4)",
        "price": 624,
        "pricePayment": 925
      },
      {
        "label": "iPad Pro 13″ (M5)",
        "price": 624,
        "pricePayment": 925
      }
    ],
    "images": [
      "/smartcases/gastropro-thekenstaender-0.webp",
      "/smartcases/gastropro-thekenstaender-1.webp",
      "/smartcases/gastropro-thekenstaender-2.webp",
      "/smartcases/gastropro-thekenstaender-3.webp",
      "/smartcases/gastropro-thekenstaender-4.webp",
      "/smartcases/gastropro-thekenstaender-5.webp",
      "/smartcases/gastropro-thekenstaender-6.webp",
      "/smartcases/gastropro-thekenstaender-7.webp"
    ]
  },
  {
    "slug": "gastropro-bodenstaender",
    "name": "GastroPro Bodenständer",
    "category": "staender",
    "description": "Freistehender Aluminium-Ständer, in 5 Minuten aufgebaut: 2-in-1-Design mit zwei Höhen (112 cm und 127 cm) für Check-in, Selbstbestellung oder Infopoint. Robust, standsicher und mit verdeckter Kabelführung. In der Payment-Variante inklusive Kartenzahlungs-Halterung und Adapter.",
    "hasPayment": true,
    "variantLabel": "Gerätemodell",
    "variants": [
      {
        "label": "iPad 11″ (A16, 10. Gen)",
        "price": 514,
        "pricePayment": 815
      },
      {
        "label": "iPad Air 11″ (M4, M3, M2)",
        "price": 514,
        "pricePayment": 815
      },
      {
        "label": "iPad Pro 11″ (M4) (5. Gen)",
        "price": 514,
        "pricePayment": 815
      },
      {
        "label": "iPad Pro 11″ (M5)",
        "price": 514,
        "pricePayment": 815
      },
      {
        "label": "iPad Air 13″ (M4, M3, M2)",
        "price": 624,
        "pricePayment": 925
      },
      {
        "label": "iPad Pro 13″ (M4)",
        "price": 624,
        "pricePayment": 925
      },
      {
        "label": "iPad Pro 13″ (M5)",
        "price": 624,
        "pricePayment": 925
      }
    ],
    "images": [
      "/smartcases/gastropro-bodenstaender-0.webp",
      "/smartcases/gastropro-bodenstaender-1.webp",
      "/smartcases/gastropro-bodenstaender-2.webp",
      "/smartcases/gastropro-bodenstaender-3.webp",
      "/smartcases/gastropro-bodenstaender-4.webp",
      "/smartcases/gastropro-bodenstaender-5.webp",
      "/smartcases/gastropro-bodenstaender-6.webp",
      "/smartcases/gastropro-bodenstaender-7.webp"
    ]
  },
  {
    "slug": "klarstand-ipad",
    "name": "KlarStand iPad-Ständer",
    "category": "staender",
    "description": "Vielseitiger, schlanker iPad-Ständer für Wand, Theke oder Tisch: Schlichtes Design, solide Verarbeitung und flexibel montierbar – die preisbewusste Lösung für Kasse, Check-in oder Kundenanzeige.",
    "hasPayment": false,
    "variantLabel": "Gerätemodell",
    "price": 248,
    "images": [
      "/smartcases/klarstand-ipad-0.webp",
      "/smartcases/klarstand-ipad-1.webp",
      "/smartcases/klarstand-ipad-2.webp",
      "/smartcases/klarstand-ipad-3.webp",
      "/smartcases/klarstand-ipad-4.webp",
      "/smartcases/klarstand-ipad-5.webp",
      "/smartcases/klarstand-ipad-6.webp",
      "/smartcases/klarstand-ipad-7.webp"
    ]
  },
  {
    "slug": "smartcase-universal-staender",
    "name": "SmartCase Universal-Tablet-Ständer",
    "category": "staender",
    "description": "Stabiler und preiswerter Universal-Ständer für verschiedene Tablets (u.a. iPad, Lenovo, Google Pixel Tablet). Die unkomplizierte Lösung, wenn ein Tablet sicher und ordentlich am Platz stehen soll.",
    "hasPayment": false,
    "variantLabel": "Gerätemodell",
    "price": 139,
    "images": [
      "/smartcases/smartcase-universal-staender-0.webp",
      "/smartcases/smartcase-universal-staender-1.webp",
      "/smartcases/smartcase-universal-staender-2.webp",
      "/smartcases/smartcase-universal-staender-3.webp",
      "/smartcases/smartcase-universal-staender-4.webp",
      "/smartcases/smartcase-universal-staender-5.webp",
      "/smartcases/smartcase-universal-staender-6.webp",
      "/smartcases/smartcase-universal-staender-7.webp"
    ]
  },
  {
    "slug": "gastropro-rollenset",
    "name": "GastroPro Rollen-Set für Bodenständer",
    "category": "staender",
    "description": "Nachrüstbares Rollen-Set für den GastroPro Bodenständer: Macht den Ständer mobil, sodass er je nach Tagesgeschäft schnell umpositioniert werden kann – vom Eingang zur Terrasse in Sekunden.",
    "hasPayment": false,
    "variantLabel": "Gerätemodell",
    "price": 139,
    "images": [
      "/smartcases/gastropro-rollenset-0.webp",
      "/smartcases/gastropro-rollenset-1.webp",
      "/smartcases/gastropro-rollenset-2.webp",
      "/smartcases/gastropro-rollenset-3.webp",
      "/smartcases/gastropro-rollenset-4.webp",
      "/smartcases/gastropro-rollenset-5.webp"
    ]
  },
  {
    "slug": "kellnerplus-pro-sonnenblende",
    "name": "KellnerPlus Pro Sonnenblende",
    "category": "zubehoer",
    "description": "Blend- und Hitzeschutz für den Außeneinsatz: Die leichte Stoff-Blende wird einfach am Case befestigt, reduziert Spiegelungen und schützt das Display vor direkter Sonne – perfekt für Terrasse und Biergarten.",
    "hasPayment": false,
    "variantLabel": "Passendes Case",
    "variants": [
      {
        "label": "KassenPilot Case für iPad mini (7./6. Gen)",
        "price": 62
      },
      {
        "label": "KellnerPlus Pro Case für iPad mini (7./6. Gen)",
        "price": 62
      },
      {
        "label": "KassenPilot Case für iPad (A16, 10. Gen)",
        "price": 70
      },
      {
        "label": "KellnerPlus Pro Case für iPad (A16, 10. Gen)",
        "price": 70
      }
    ],
    "images": [
      "/smartcases/kellnerplus-pro-sonnenblende-0.webp",
      "/smartcases/kellnerplus-pro-sonnenblende-1.webp",
      "/smartcases/kellnerplus-pro-sonnenblende-2.webp",
      "/smartcases/kellnerplus-pro-sonnenblende-3.webp",
      "/smartcases/kellnerplus-pro-sonnenblende-4.webp",
      "/smartcases/kellnerplus-pro-sonnenblende-5.webp",
      "/smartcases/kellnerplus-pro-sonnenblende-6.webp",
      "/smartcases/kellnerplus-pro-sonnenblende-7.webp"
    ]
  },
  {
    "slug": "kellnerplus-pro-schultergurt",
    "name": "KellnerPlus Pro Schultergurt",
    "category": "zubehoer",
    "description": "Ergonomischer Schultergurt aus Nylon und Neopren: Hält das iPad sicher und griffbereit – entlastet dein Team bei langen Schichten im mobilen Einsatz.",
    "hasPayment": false,
    "variantLabel": "Gerätemodell",
    "price": 24,
    "images": [
      "/smartcases/kellnerplus-pro-schultergurt-0.webp",
      "/smartcases/kellnerplus-pro-schultergurt-1.webp",
      "/smartcases/kellnerplus-pro-schultergurt-2.webp",
      "/smartcases/kellnerplus-pro-schultergurt-3.webp",
      "/smartcases/kellnerplus-pro-schultergurt-4.webp"
    ]
  },
  {
    "slug": "kassenpilot-handgriff",
    "name": "KassenPilot Handgriff",
    "category": "zubehoer",
    "description": "Der komfortable Handgriff für alle KassenPilot Cases: Sicherer, ermüdungsfreier Halt beim mobilen Kassieren – aus strapazierfähigem Nylon und Neopren.",
    "hasPayment": false,
    "variantLabel": "Ausführung",
    "variants": [
      {
        "label": "Passend für: KassenPilot Case für Lenovo Tab M8 (2./3. Gen)",
        "price": 46
      },
      {
        "label": "Passend für: KassenPilot Case für iPad (7./8./9. Gen) oder Lenovo Tab K10",
        "price": 46
      },
      {
        "label": "Passend für: KassenPilot Case für iPad mini (6. Gen)",
        "price": 46
      }
    ],
    "images": [
      "/smartcases/kassenpilot-handgriff-0.webp",
      "/smartcases/kassenpilot-handgriff-1.webp",
      "/smartcases/kassenpilot-handgriff-2.webp"
    ]
  },
  {
    "slug": "glasschild-ipad-102-105",
    "name": "GlasSchild Panzerglas iPad 10,2″/10,5″",
    "category": "schutz",
    "description": "Panzerglas-Displayschutz für iPad 10,2″ und 10,5″: Schützt vor Kratzern und Fingerabdrücken bei glasklarer Sicht – blasenfrei anzubringen, unverzichtbar bei Kassen mit Dauernutzung.",
    "hasPayment": false,
    "variantLabel": "Gerätemodell",
    "price": 50,
    "images": [
      "/smartcases/glasschild-ipad-102-105-0.webp"
    ]
  },
  {
    "slug": "glasschild-ipad-129",
    "name": "GlasSchild Panzerglas iPad 12,9″ (3./4. Gen)",
    "category": "schutz",
    "description": "Ultradünnes Panzerglas für das iPad 12,9″ (4. Gen, abwärtskompatibel zur 3. Gen): Kristallklare Sicht, zuverlässiger Schutz vor Kratzern und Abnutzung.",
    "hasPayment": false,
    "variantLabel": "Gerätemodell",
    "price": 50,
    "images": [
      "/smartcases/glasschild-ipad-129-0.webp"
    ]
  },
  {
    "slug": "glasschild-ipad-mini",
    "name": "GlasSchild Panzerglas iPad mini (4./5. Gen)",
    "category": "schutz",
    "description": "Panzerglas-Schutz für das iPad mini (4./5. Gen): Blasenfreie Anbringung, klare Sicht und wirksamer Schutz vor Kratzern im täglichen Einsatz.",
    "hasPayment": false,
    "variantLabel": "Gerätemodell",
    "price": 48,
    "images": [
      "/smartcases/glasschild-ipad-mini-0.webp"
    ]
  }
];
